(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spctra-configurator"] && !Shopify.designMode) return;
  try {
    
(function(){
  /* ---------- Theme: HELL ist Standard, "dark" wird gespeichert ---------- */
  function applySavedTheme(){
    try{
      if(localStorage.getItem('spctra-theme')==='dark'){
        document.documentElement.setAttribute('data-theme','dark');
      }
    }catch(e){}
  }
  applySavedTheme();

  function initHero(root){
    if(root.dataset.spInit) return;
    root.dataset.spInit='1';

    var toggle=root.querySelector('[data-theme-toggle]');
    if(toggle){
      toggle.addEventListener('click',function(){
        var h=document.documentElement;
        var dark=h.getAttribute('data-theme')==='dark';
        if(dark){ h.removeAttribute('data-theme'); } else { h.setAttribute('data-theme','dark'); }
        try{ localStorage.setItem('spctra-theme', dark?'light':'dark'); }catch(e){}
      });
    }

    var mapEl=root.querySelector('[data-variant-map]');
    if(!mapEl) return;
    var variants=[];
    try{ variants=JSON.parse(mapEl.textContent)||[]; }catch(e){ variants=[]; }
    var wrap=root.querySelector('[data-sp-product]');
    var priceEl=root.querySelector('[data-price]');
    var addBtn=root.querySelector('[data-add-to-cart]');
    var feedback=root.querySelector('[data-feedback]');
    var qtyInput=root.querySelector('[data-qty]');

    /* SPCTRA-Farbnamen → Swatch-Farbe (im Theme-Editor per "Swatch-Farbwerte" überschreibbar) */
    var COLORMAP={
      'crystal':'#e6eaf3',
      'obsidian':'#14151b',
      'amethyst':'#7b5cff',
      'amber':'#ff7a1a',
      'ruby':'#ff2d55',
      'rose':'#ff8ac2',
      'sapphire':'#1e3a8a',
      'turquoise':'#12e0d4',
      'citrine':'#ffd60a'
    };
    function colorFor(name){
      var k=(name||'').toLowerCase().trim();
      return COLORMAP[k]||'#8a8f9d';
    }
    function money(cents){
      return '<span>'+(cents/100).toFixed(2).replace('.',',')+'</span><span class="cur">€</span>';
    }

    var outerIdx=parseInt(root.dataset.outerIndex,10); if(isNaN(outerIdx)) outerIdx=-1;
    var innerIdx=parseInt(root.dataset.innerIndex,10); if(isNaN(innerIdx)) innerIdx=-1;

    /* ---------- Ansichten ---------- */
    var views=root.querySelectorAll('.sp-view');
    var activeView='front';
    function setView(target){
      activeView=target;
      views.forEach(function(v){v.classList.toggle('active',v.getAttribute('data-view')===target);});
      root.querySelectorAll('.sp-thumb').forEach(function(x){x.classList.toggle('active',x.getAttribute('data-target')===target);});
    }
    /* ---------- Bilder aus den Produktmedien ---------- */
    var hideMock=root.dataset.hideMockups==='1';
    var userPickedView=false;
    var known={outer:{},inner:{}};
    root.querySelectorAll('[data-swgroup]').forEach(function(g){
      var k=g.dataset.swgroup;
      g.querySelectorAll('.sp-swatch').forEach(function(b){ known[k][(b.dataset.value||'').toLowerCase()]=true; });
    });
    function parseKey(s){
      var m=/(?:^|[^a-z0-9])(?:spctra-)?([a-z]+)-([a-z]+)-(\d+)/.exec((s||'').toLowerCase());
      if(m&&known.outer[m[1]]&&known.inner[m[2]]) return {o:m[1],i:m[2],n:parseInt(m[3],10)};
      return null;
    }
      var mediaItems=[];
    root.querySelectorAll('.sp-thumb--media').forEach(function(btn){
      var key=parseKey(btn.dataset.alt)||parseKey(btn.dataset.file);
      var vw=root.querySelector('.sp-view[data-view="'+btn.dataset.target+'"]');
      if(vw&&key) vw.classList.add('sp-view--n'+key.n);
      mediaItems.push({btn:btn,view:btn.dataset.target,key:key});
    });
    root.querySelectorAll('.sp-thumb--mock').forEach(function(b){ b.style.order=90; });
    function updateRender(){
      var o=(state.outer||'').toLowerCase(), i=(state.inner||'').toLowerCase();
      var first=null, hasCombo=false;
      mediaItems.forEach(function(it){
        var show=!it.key||(it.key.o===o&&it.key.i===i);
        it.btn.hidden=!show;
        it.btn.style.order=it.key?it.key.n:50;
        if(show&&it.key){ hasCombo=true; if(!first||it.key.n<first.key.n) first=it; }
      });
      if(!first){ mediaItems.some(function(it){ if(!it.btn.hidden){ first=it; return true; } return false; }); }
      root.classList.toggle('sp-has-renders',hideMock&&hasCombo);
      var cur=null;
      mediaItems.forEach(function(it){ if(it.view===activeView) cur=it; });
      if(cur&&cur.btn.hidden){
        var same=null;
        if(cur.key){
          mediaItems.forEach(function(it){
            if(!it.btn.hidden&&it.key&&it.key.n===cur.key.n) same=it;
          });
        }
        setView(same?same.view:(first?first.view:'front'));
      }
      else if(first&&(!userPickedView||(hideMock&&hasCombo&&activeView.indexOf('media-')!==0))){ setView(first.view); }
    }

    /* ---------- Zustand ---------- */
    var state={outer:null,inner:null,outerHex:'',innerHex:''};
    function currentVariant(){
      for(var i=0;i<variants.length;i++){
        var v=variants[i];
        var okO = outerIdx<0 || v.o[outerIdx]===state.outer;
        var okI = innerIdx<0 || v.o[innerIdx]===state.inner;
        if(okO && okI) return v;
      }
      return null;
    }
    function applyVisual(){
      if(outerIdx>-1 && wrap) wrap.style.setProperty('--outer',state.outerHex||colorFor(state.outer));
      if(innerIdx>-1 && wrap) wrap.style.setProperty('--inner',state.innerHex||colorFor(state.inner));
      var v=currentVariant();
      if(v){
        priceEl.innerHTML=money(v.p);
        addBtn.disabled=!v.a;
        addBtn.textContent=v.a?'In den Warenkorb':'Nicht verfügbar';
        addBtn.dataset.variantId=v.id;
      } else if(variants.length){
        priceEl.innerHTML=money(variants[0].p);
        if(outerIdx<0 && innerIdx<0){
          addBtn.disabled=!variants[0].a;
          addBtn.dataset.variantId=variants[0].id;
        } else {
          addBtn.disabled=true;
          addBtn.textContent='Kombination nicht verfügbar';
          delete addBtn.dataset.variantId;
        }
      }
      updateRender();
    }

    /* Swatches: serverseitig gerendert, hier nur Farbe + Klick-Logik */
    root.querySelectorAll('[data-swgroup]').forEach(function(group){
      var key=group.dataset.swgroup;
      var valEl=group.querySelector('[data-swval]');
      var chips=[].slice.call(group.querySelectorAll('.sp-swatch'));
      function pick(b){
        state[key]=b.dataset.value;
        state[key+'Hex']=b.dataset.hex||'';
      }
      chips.forEach(function(b){
        b.style.setProperty('--sw',b.dataset.hex||colorFor(b.dataset.value));
        if(b.classList.contains('active')) pick(b);
        b.addEventListener('click',function(){
          pick(b);
          chips.forEach(function(x){x.classList.remove('active');});
          b.classList.add('active');
          if(valEl) valEl.textContent=b.dataset.value;
          applyVisual();
        });
      });
    });
    applyVisual();

    /* Thumb-Klicks */
    root.querySelectorAll('.sp-thumb').forEach(function(t){
      t.addEventListener('click',function(){
        userPickedView=true;
        setView(t.getAttribute('data-target'));
      });
    });

    /* Menge */
    root.querySelectorAll('.sp-qty button').forEach(function(b){
      b.addEventListener('click',function(){
        var v=parseInt(qtyInput.value,10)||1;
        qtyInput.value=Math.min(99,Math.max(1,v+parseInt(b.dataset.q,10)));
      });
    });
    qtyInput.addEventListener('change',function(){
      var v=parseInt(qtyInput.value,10)||1;
      qtyInput.value=Math.min(99,Math.max(1,v));
    });

    /* Warenkorb */
    addBtn.addEventListener('click',function(){
      var id=addBtn.dataset.variantId;
      if(!id) return;
      var qty=parseInt(qtyInput.value,10)||1;
      addBtn.disabled=true;
      addBtn.textContent='Wird hinzugefügt…';

      var cartEl=document.querySelector('cart-drawer')||document.querySelector('cart-notification');
      var sections=cartEl&&cartEl.getSectionsToRender
        ? cartEl.getSectionsToRender().map(function(s){return s.id;})
        : ['cart-icon-bubble'];

      fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({
          id:parseInt(id,10),
          quantity:qty,
          sections:sections.join(','),
          sections_url:window.location.pathname
        })
      }).then(function(r){
        if(!r.ok) throw new Error('cart');
        return r.json();
      }).then(function(json){
        if(cartEl&&cartEl.renderContents){
          cartEl.classList.remove('is-empty');
          cartEl.renderContents(json);           /* Drawer öffnen + Zähler aktualisieren */
        }else if(json.sections&&json.sections['cart-icon-bubble']){
          var bubble=document.getElementById('cart-icon-bubble');
          if(bubble) bubble.innerHTML=json.sections['cart-icon-bubble'];
        }
        addBtn.textContent='✓ Hinzugefügt';
        feedback.hidden=false;
        feedback.style.color='';
        feedback.innerHTML='Im Warenkorb — <a href="/cart" style="color:inherit;text-decoration:underline">zur Kasse</a>';
        setTimeout(function(){
          addBtn.disabled=false;
          addBtn.textContent='In den Warenkorb';
        },2200);
      }).catch(function(){
        addBtn.disabled=false;
        addBtn.textContent='In den Warenkorb';
        feedback.hidden=false;
        feedback.style.color='#d6164d';
        feedback.textContent='Konnte nicht hinzugefügt werden — bitte nochmal versuchen.';
      });
    });
    }

  function initAll(scope){
    (scope||document).querySelectorAll('.sp-hero').forEach(initHero);
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){initAll();});
  } else { initAll(); }
  document.addEventListener('shopify:section:load',function(e){initAll(e.target);});
})();

  } catch(e) { console.error(e); }
})();
})();
